export const setCurrentHash = () => {}
